import { render, staticRenderFns } from "./Legales.vue?vue&type=template&id=5262890e&"
import script from "./Legales.vue?vue&type=script&lang=js&"
export * from "./Legales.vue?vue&type=script&lang=js&"
import style0 from "vue-slim-tabs/themes/default.css?vue&type=style&index=0&lang=css&"
import style1 from "./Legales.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports